import React from 'react';
import clsx from 'clsx';
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";

const FillCircleSVG = () => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
    <g filter="url(#filter0_i_18507_31226)">
      <circle cx="20.5" cy="20" r="20" fill="#F0F0F0"/>
    </g>
    <defs>
      <filter id="filter0_i_18507_31226" x="0.5" y="0" width="40" height="44" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_18507_31226"/>
      </filter>
    </defs>
  </svg>)
}

const CurrentCircleSVG = ({ color = '#445B4B', checkColor = 'white' }) => {
  return ( <svg xmlns="http://www.w3.org/2000/svg" width="27" height="28" viewBox="0 0 27 28" fill="none">
    <rect x="-0.000976562" y="0.5" width="27.0012" height="27.0012" rx="13.5006" fill={color}/>
    <path d="M18.512 8.88806C18.7497 8.66174 19.0661 8.53662 19.3943 8.5391C19.7225 8.54158 20.0369 8.67148 20.2712 8.90137C20.5055 9.13126 20.6413 9.44317 20.65 9.77129C20.6586 10.0994 20.5395 10.4181 20.3177 10.66L13.5843 19.081C13.4685 19.2057 13.3288 19.3058 13.1734 19.3753C13.0181 19.4447 12.8503 19.4822 12.6802 19.4853C12.51 19.4885 12.341 19.4573 12.1832 19.3936C12.0254 19.3299 11.882 19.2351 11.7617 19.1148L7.29639 14.6494C7.17204 14.5336 7.0723 14.3938 7.00312 14.2386C6.93395 14.0833 6.89675 13.9157 6.89375 13.7458C6.89075 13.5758 6.92202 13.407 6.98567 13.2494C7.04933 13.0918 7.14408 12.9487 7.26426 12.8285C7.38445 12.7083 7.52761 12.6135 7.68521 12.5499C7.84281 12.4862 8.01162 12.455 8.18156 12.458C8.35151 12.461 8.51911 12.4982 8.67436 12.5673C8.82962 12.6365 8.96935 12.7363 9.08522 12.8606L12.619 16.3927L18.4799 8.92518C18.4905 8.91219 18.5018 8.8998 18.5137 8.88806H18.512Z" fill={checkColor}/>
    </svg>)
}

const CurrentCrownSVG = ({ color }) => {
  return (
    <svg className="w-[13px] h-[8px]" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.5 0L11.6962 7.5H1.30385L6.5 0Z" fill={color} />
    </svg>
  )
}



export default function ExtendedCartBreadcrumbs ({ translations, activeIndex, settings }) {
  const steps = [
    translations.address_info,
    translations.shipping_options
  ]
 
  const { progress_bar_accent_color,  progress_bar_accent_font } =  settings;

  const isMobile = useMobileBreakpoint('1024px');
  return (
    <div className='extended-cart__progress'>


          <div
              className= "extended-cart__progress-fill h-[8px]"
              style={{
                width: `${(activeIndex / (steps.length - 1)) * 100}%`,
                backgroundColor: progress_bar_accent_color,
              }}
            />
      {steps.map((step, index) => {
        return (
          <div
            key={`breadcrumb_${index}`}
            className={clsx(
              'extended-cart__progress-step flex flex-col items-center relative',
              {
                start: index === 0,
                middle: index === 1,
                end: index === 2,
              }
            )}
          >


            <div className="extended-cart__progress-circle z-10">
              <FillCircleSVG />
              {activeIndex >= index ? (
                <div className="extended-cart__progress-circle-fill">
                  <CurrentCircleSVG
                    color={progress_bar_accent_color}
                    checkColor={progress_bar_accent_font}
                  />
                </div>
              ) : (
                <div className="extended-cart__progress-circle-fill">
                  <div className="extended-cart__progress-circle-next">
                    <span>{index + 1}</span>
                  </div>
                </div>
              )}
            </div>

            <div
  className={clsx(
    'extended-cart__progress-label absolute top-[50px] flex flex-col',
    {
      'left-0 items-start': index === 0,
      'right-0 items-end': index === 2,
      'left-1/2 -translate-x-1/2 items-center': index === 1,
      'lg:left-1/2 lg:-translate-x-1/2 lg:items-center': true,
    }
  )}
>
  <div className={clsx(
    'mb-[2px]',
    {
      'ml-[14px] lg:ml-0': index === 0,
      'mr-[14px] lg:mr-0': index === 2,
    }
  )}>
    <CurrentCrownSVG
      color={ activeIndex >= index ? progress_bar_accent_color : "#D9D9D9"}
    />
  </div>
  {index === 0 ? (
    <button
      type="button"
      className={clsx({
        'extended-cart__progress-label-current': activeIndex >= index,
        'extended-cart__progress-label-next': activeIndex < index,
      })}
      style={
        activeIndex >= index
          ? {
              backgroundColor: progress_bar_accent_color,
              color: progress_bar_accent_font,
            }
          : undefined
      }
      onClick={() => window.location.href = '/cart'}
    >
      { isMobile ? step.split(' ')[0] : step }
    </button>
  ) : (
    <div
      className={clsx({
        'extended-cart__progress-label-current': activeIndex >= index,
        'extended-cart__progress-label-next': activeIndex < index,
      })}
      style={
        activeIndex >= index
          ? {
              backgroundColor: progress_bar_accent_color,
              color: progress_bar_accent_font,
            }
          : undefined
      }
    >
      { isMobile ? step.split(' ')[0] : step }
    </div>
  )}
</div>
          </div>
        )
      })}
    </div>
  )
}